import React from 'react';
import {connect} from 'react-redux';
import moment from 'moment';

import ClientTimestamp    from 'app/components/common/client-timestamp';
import Icon               from 'app/components/common/icon';
import Link               from 'app/components/common/link';
import Meta               from 'app/components/common/meta';
import MainLayout         from 'app/components/layout/main-layout';
import GrantSysDuck       from 'app/ducks/grants-system';
import format             from 'app/helpers/format';
import helpers            from 'app/helpers/grant-system';
import paths              from 'app/paths';
import AuthSlx            from 'app/selectors/auth';
import EntitiesSlx        from 'app/selectors/entities';



const {
  AppStatuses,
} = helpers;

const renderStatusMsg = (app, program) => {
  if (app.status === AppStatuses.DRAFT) {
    if (!program?.closeDateStr) return null;
    const deadline = moment.utc(program.closeDateStr).format('MMMM D, YYYY');
    return (<>
      Submission deadline: {deadline}
    </>);
  }
  if (app.status === AppStatuses.REVIEW) {
    return (<>
      Submitted on <ClientTimestamp timestamp={app.submittedTs} />
    </>);
  }
  if (app.status === AppStatuses.APPROVED) {
    if (!app.amountAwarded) return null;
    return <strong>{format.usd(app.amountAwarded)}</strong>;
  }
  return null;
};

class PageGrantApps extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  renderApps() {
    const {apps} = this.props;
    if (!apps) return <p className="_italic">loading...</p>;
    if (!apps.length) return <p className="_italic">No applications to show.</p>;

    return (
      <div className="pg-gapps-gapps">
        {apps.map((app) => {
          const program = this.props.programMap[app.grantProgramId];
          const statusMsg = renderStatusMsg(app, program);
          return (
            <Link key={app.id} className="pg-gapps-gapp" href={paths.grantApp(app.id)}>
              <div className="pg-gapps-gapp-title">{program?.title || 'Application'}</div>
              <div className="pg-gapps-gapp-status">
                <div className={`pg-gapps-gapp-status-chip ${app.status}`}>{app.status}</div>
                <div className="pg-gapps-gapp-status-msg">{statusMsg}</div>
              </div>
              <Icon.Caret className="pg-gapps-gapp-caret" direction="right" />
            </Link>
          );
        })}
      </div>
    );
  }

  render() {
    const {apps} = this.props;
    const title = 'My Grant Applications';

    return (
      <MainLayout className="pg-gapps">
        <Meta title={`${title} | Millie`} />
        <div className="widther">
          {this.renderApps()}
        </div>
        {/* <pre>{JSON.stringify({props: this.props},null,4)}</pre> */}
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
  // app: GrantSysDuck.Slx.pathApp(state),
  // program: GrantSysDuck.Slx.pathAppProgram(state),
  apps: GrantSysDuck.Slx.myApps(state),
  currentUser: AuthSlx.currentUser(state),
  programMap: EntitiesSlx.grantPrograms(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageGrantApps);
